// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1xW8v","content":"styles_content__206ZJ","row":"styles_row__2Y50u","footer":"styles_footer__2Tg11","phraseLength":"styles_phraseLength__K0GA6"};